module.exports = __webpack_public_path__ + "static/telephone-ae8596c191df6a8b5c49b4d0334bf23b.png";